var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.15,
    height: 31.15,
    viewBox: "0 0 31.15 31.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M15.579,0h-.008A15.565,15.565,0,0,0,2.965,24.7L1.024,30.49l5.987-1.914A15.572,15.572,0,1,0,15.579,0Z",
    fill: "#1f94a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M122.111,128.788a3.6,3.6,0,0,1-2.505,1.729c-.667.136-1.538.245-4.471-.922a15.751,15.751,0,0,1-6.355-5.389,6.857,6.857,0,0,1-1.516-3.7,3.849,3.849,0,0,1,1.305-2.982,1.9,1.9,0,0,1,1.305-.44c.158,0,.3.008.428.014.375.015.563.037.811.605.308.712,1.058,2.471,1.147,2.651a.7.7,0,0,1,.054.663,2.12,2.12,0,0,1-.413.562c-.188.208-.367.368-.555.591-.172.195-.367.4-.15.763a10.956,10.956,0,0,0,2.071,2.471,9.476,9.476,0,0,0,2.993,1.772.833.833,0,0,0,.9-.136,14.9,14.9,0,0,0,1-1.268.729.729,0,0,1,.916-.267c.345.115,2.168.98,2.543,1.16s.622.267.713.418A2.938,2.938,0,0,1,122.111,128.788Z",
    transform: "translate(-99.029 -108.098)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWhatsapp);
export default __webpack_public_path__ + "static/media/blue-whatsapp.ed709952300c877e14707de2670c2577.svg";
export { ForwardRef as ReactComponent };